/* eslint-disable */

let pendingRequests = 0
let setVisible = null

export const bindLoading = (setter) => {
  setVisible = setter || (() => {})
  if (setter && pendingRequests > 0) {
    setter(true)
  }
}

const notify = () => {
  if (setVisible) {
    setVisible(pendingRequests > 0)
  }
}

export const requestStarted = () => {
  pendingRequests += 1
  notify()
}

export const requestEnded = () => {
  pendingRequests = Math.max(0, pendingRequests - 1)
  notify()
}
